// const validateNationalIdFunc = (nationalId) => { let yy = 0; let yv = 0; yv = parseInt(yv); let isValid; for (let i = 0; i < nationalId.length; i++) { yv = nationalId[i] * (nationalId.length - i); yy += yv; } let x = yy % 11; if (x === 0) { isValid = true; } else { isValid = false; } yy = 0; return isValid; };
// function validateIranianNationalCode(nationalCode) {
//   try {
//     let total = 0;
//     let splittedNationalCode = nationalCode.split("");

//     for (let i = 0; i < 9; i++) {
//       total += parseInt(splittedNationalCode[i]) * (10 - i);
//     }

//     if (parseInt(splittedNationalCode[9]) < 2) {
//       return (total - parseInt(splittedNationalCode[9])) % 11 === 0;
//     } else {
//       return (total + parseInt(splittedNationalCode[9])) % 11 === 0;
//     }
//   } catch (e) {
//     console.error(e);
//     return false;
//   }
// }
export function validateIranianNationalCode(nationalID) {
  // Must be exactly 10 digits
  if (!/^\d{10}$/.test(nationalID)) {
    return false;
  }

  // Reject repeated digit codes (e.g., 0000000000, 1111111111, ...)
  const repeatedDigits = [
    "0000000000",
    "1111111111",
    "2222222222",
    "3333333333",
    "4444444444",
    "5555555555",
    "6666666666",
    "7777777777",
    "8888888888",
    "9999999999",
  ];
  if (repeatedDigits.includes(nationalID)) {
    return false;
  }

  // Checksum calculation
  let total = 0;
  for (let i = 0; i < 9; i++) {
    total += parseInt(nationalID[i], 10) * (10 - i);
  }

  const lastDigit = parseInt(nationalID[9], 10);
  const remainder = total % 11;

  return (remainder < 2 && remainder === lastDigit) || (remainder >= 2 && 11 - remainder === lastDigit);
}
const validateIBAN = (sheba) => {
  try {
    if (!sheba || typeof sheba !== "string" || sheba.length < 6) {
      return false;
    }

    // تبدیل حروف اول به اعداد
    let formattedSheba =
      (sheba.charCodeAt(0) - 55).toString() + (sheba.charCodeAt(1) - 55).toString() + sheba.substring(2);

    // جابجایی شش رقم اول به انتهای رشته
    formattedSheba = formattedSheba.substring(6) + formattedSheba.substring(0, 6);

    // محاسبه باقی‌مانده تقسیم بر 97 بدون استفاده از BigInt
    let remainder = 0;
    for (let i = 0; i < formattedSheba.length; i++) {
      remainder = (remainder * 10 + parseInt(formattedSheba[i], 10)) % 97;
    }

    return remainder === 1;
  } catch (e) {
    console.error("Invalid IBAN:", e);
    return false;
  }
};

const validate = (data, type, length, certainDate, forceLtr, checkArrayOfObjectKeyNames) => {
  let properData;
  let returnedValidityObject;
  if (data === null) {
    properData = "";
  } else if (typeof data === "string") {
    properData = data;
  } else if (typeof data === "number") {
    properData = data.toString();
  } else if (typeof data === "object") {
    properData = data?.id;
  }
  if (type === "mandatory") {
    returnedValidityObject =
      !properData || (typeof properData === "string" ? properData?.trim() === "" : null)
        ? {
            isValid: false,
            msg: forceLtr
              ? ["This field is mandatory"]
              : length
              ? [`پر کردن ${length} اجباری میباشد`]
              : ["پر کردن این فیلد اجباری می‌باشد"],
          }
        : { isValid: true, msg: "" };
  } else if (type === "definedLength") {
    returnedValidityObject =
      properData?.length === length
        ? { isValid: true, msg: "" }
        : {
            isValid: false,
            msg: forceLtr ? [`Must be ${length} digits`] : ["باید", length, " رقمی باشد"],
          };
  } else if (type === "nationalCode") {
    if (properData.length === 10) {
      let isValid = validateIranianNationalCode(properData);
      returnedValidityObject = isValid
        ? { isValid: true, msg: "" }
        : { isValid: false, msg: ["کد ملی معتبر نمی باشد"] };
    } else {
      returnedValidityObject = { isValid: false, msg: ["تعداد کاراکتر‌های کد ملی 10 رقم میباشد"] };
    }
  } else if (type === "insuranceCode") {
    if (properData.length === 10) {
      returnedValidityObject =
        properData.substring(0, 2) === "00"
          ? { isValid: true, msg: "" }
          : { isValid: false, msg: ["کد بیمه صحیح نمی باشد"] };
    } else {
      returnedValidityObject = { isValid: false, msg: ["تعداد کاراکتر‌های کد بیمه 10 رقم میباشد"] };
    }
  } else if (type === "beforePeresentTime") {
    let today = new Date().toLocaleDateString("fa-IR-u-nu-latn").replaceAll("/", "-");
    const dateArray = data ? data.split("-") : null;
    const certainDateArray = today.split("-");
    const correctObj = { isValid: true, msg: "" };
    const wrongObje = {
      isValid: false,
      msg: forceLtr ? [`Must be before today`] : ["تاریخ باید بعد از امروز باشد"],
    };
    returnedValidityObject =
      certainDate && dateArray
        ? +dateArray[0] < +certainDateArray[0]
          ? correctObj
          : +dateArray[0] !== +certainDateArray[0]
          ? wrongObje
          : +dateArray[1] < +certainDateArray[1]
          ? correctObj
          : +dateArray[1] !== +certainDateArray[1]
          ? wrongObje
          : +dateArray[2] <= +certainDateArray[2]
          ? correctObj
          : wrongObje
        : +dateArray[0] < +certainDateArray[0]
        ? correctObj
        : +dateArray[0] !== +certainDateArray[0]
        ? wrongObje
        : +dateArray[1] < +certainDateArray[1]
        ? correctObj
        : +dateArray[1] !== +certainDateArray[1]
        ? wrongObje
        : +dateArray[2] < +certainDateArray[2]
        ? correctObj
        : wrongObje;
  } else if (type === "afterPeresentTime") {
    let today = new Date().toLocaleDateString("fa-IR-u-nu-latn").replaceAll("/", "-");
    const dateArray = data ? data.split("-") : null;
    const certainDateArray = today.split("-");
    const correctObj = { isValid: true, msg: "" };
    const wrongObje = {
      isValid: false,
      msg: forceLtr ? [`Must be after today`] : ["تاریخ باید بعد از امروز باشد"],
    };
    returnedValidityObject =
      certainDate && dateArray
        ? +dateArray[0] > +certainDateArray[0]
          ? correctObj
          : +dateArray[0] !== +certainDateArray[0]
          ? wrongObje
          : +dateArray[1] > +certainDateArray[1]
          ? correctObj
          : +dateArray[1] !== +certainDateArray[1]
          ? wrongObje
          : +dateArray[2] >= +certainDateArray[2]
          ? correctObj
          : wrongObje
        : +dateArray[0] > +certainDateArray[0]
        ? correctObj
        : +dateArray[0] !== +certainDateArray[0]
        ? wrongObje
        : +dateArray[1] > +certainDateArray[1]
        ? correctObj
        : +dateArray[1] !== +certainDateArray[1]
        ? wrongObje
        : +dateArray[2] > +certainDateArray[2]
        ? correctObj
        : wrongObje;
  } else if (type === "phoneNumber" || type === "cellphone") {
    if (
      properData.length === 11 ||
      (properData.length === 12 && properData.startsWith("98")) ||
      (properData.length === 13 && properData.startsWith("+98"))
    ) {
      let numRegex = new RegExp("^(\\+98|0)?9\\d{9}$");
      let phoneIsValid = numRegex.test(properData);
      if (phoneIsValid) {
        returnedValidityObject = { isValid: true, msg: "" };
      } else {
        returnedValidityObject = { isValid: false, msg: ["تلفن‌همراه معتبر نمی باشد"] };
      }
    } else {
      returnedValidityObject = { isValid: false, msg: ["تلفن‌همراه 11 رقمی می باشد"] };
    }
  } else if (type === "email") {
    let numRegex = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
    let phoneIsValid = numRegex.test(properData);
    if (phoneIsValid) {
      returnedValidityObject = { isValid: true, msg: "" };
    } else {
      returnedValidityObject = { isValid: false, msg: ["ایمیل معتبر نمی باشد"] };
    }
  } else if (type === "postalCode") {
    if (properData.length === 10) {
      let postalCodeRegex = new RegExp(/\b(?!(d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/);
      let postalCodeIsValid = postalCodeRegex.test(properData);
      if (postalCodeIsValid) {
        returnedValidityObject = { isValid: true, msg: "" };
      } else {
        returnedValidityObject = {
          isValid: false,
          msg: forceLtr ? ["Postal code is not valid"] : ["کدپستی معتبر نیست"],
        };
      }
    } else {
      returnedValidityObject = {
        isValid: false,
        msg: forceLtr ? ["Postal dode must be 10 digits"] : ["کدپستی باید 10 رقم باشد"],
      };
    }
  } else if (type === "afterCertainDate") {
    const dateArray = data ? data.split("-") : null;
    const certainDateArray = certainDate?.value?.split("-");
    const correctObj = { isValid: true, msg: "" };
    const wrongObje = {
      isValid: false,
      msg: forceLtr
        ? [`Must be after ${certainDate.label}`]
        : [" تاریخ باید بعد از", certainDate.label, "باشد"],
    };
    const dataIsMandatoryObj = {
      isValid: false,
      msg: forceLtr ? [`field is mandatory`] : [" وارد کردن این فیلد اجباری میباشد"],
    };
    returnedValidityObject = dateArray
      ? certainDate?.value && dateArray
        ? certainDate?.canBeCertainDate
          ? +dateArray[0] > +certainDateArray[0]
            ? correctObj
            : +dateArray[0] !== +certainDateArray[0]
            ? wrongObje
            : +dateArray[1] > +certainDateArray[1]
            ? correctObj
            : +dateArray[1] !== +certainDateArray[1]
            ? wrongObje
            : +dateArray[2] >= +certainDateArray[2]
            ? correctObj
            : wrongObje
          : +dateArray[0] > +certainDateArray[0]
          ? correctObj
          : +dateArray[0] !== +certainDateArray[0]
          ? wrongObje
          : +dateArray[1] > +certainDateArray[1]
          ? correctObj
          : +dateArray[1] !== +certainDateArray[1]
          ? wrongObje
          : +dateArray[2] > +certainDateArray[2]
          ? correctObj
          : correctObj
        : wrongObje
      : dataIsMandatoryObj;
  } else if (type === "beforeCertainDate") {
    const dateArray = data ? data?.split("-") : null;
    const certainDateArray = certainDate?.value?.split("-");
    const correctObj = { isValid: true, msg: "" };
    const wrongObje = {
      isValid: false,
      msg: forceLtr
        ? [`Must be before ${certainDate.label}`]
        : [" تاریخ باید قبل از", certainDate.label, "باشد"],
    };
    const dataIsMandatoryObj = {
      isValid: false,
      msg: forceLtr ? [`field is mandatory`] : [" وارد کردن این فیلد اجباری میباشد"],
    };
    returnedValidityObject = dateArray
      ? certainDate?.value && dateArray
        ? certainDate?.canBeCertainDate
          ? +dateArray[0] < +certainDateArray[0]
            ? correctObj
            : +dateArray[0] !== +certainDateArray[0]
            ? wrongObje
            : +dateArray[1] < +certainDateArray[1]
            ? correctObj
            : +dateArray[1] !== +certainDateArray[1]
            ? wrongObje
            : +dateArray[2] <= +certainDateArray[2]
            ? correctObj
            : wrongObje
          : +dateArray[0] < +certainDateArray[0]
          ? correctObj
          : +dateArray[0] !== +certainDateArray[0]
          ? wrongObje
          : +dateArray[1] < +certainDateArray[1]
          ? correctObj
          : +dateArray[1] !== +certainDateArray[1]
          ? wrongObje
          : +dateArray[2] < +certainDateArray[2]
          ? correctObj
          : wrongObje
        : correctObj
      : dataIsMandatoryObj;
  } else if (type === "suggestion") {
    if (data) {
      returnedValidityObject = { isValid: true, msg: "" };
    } else if (!data && length === "mandatory") {
      returnedValidityObject = {
        isValid: false,
        msg: forceLtr ? ["This field is mandatory!"] : ["پرکردن این فیلد اجباری می‌باشد"],
      };
    } else if (!data && length === "notFromOptions") {
      returnedValidityObject = {
        isValid: false,
        msg: forceLtr ? ["Must be choosen from options"] : ["لطفا تنها از گزینه‌ها انتخاب کنید"],
      };
    }
  } else if (type === "securedPassword") {
    returnedValidityObject =
      !properData || (typeof properData === "string" ? properData?.trim() === "" : null)
        ? {
            isValid: false,
            msg: forceLtr ? ["This field is mandatory"] : ["پرکردن این فیلد اجباری می‌باشد"],
          }
        : properData?.length < 10
        ? {
            isValid: false,
            msg: forceLtr ? [`Must be at least 10 digits`] : [" مقدار وارد شده باید حداقل 10 رقمی باشد"],
          }
        : /[A-Z]/.test(properData) && /[a-z]/.test(properData) && /\d/.test(properData)
        ? { isValid: true, msg: "" }
        : {
            isValid: false,
            msg: forceLtr ? ["Password is not acceptable"] : ["رمز عبورد وارد شده قابل قبول نمی‌باشد"],
          };
  } else if (type === "atLeastOneItem") {
    if (data && Array.isArray(data) && data[0]) {
      const filteredArrayOfItems = data.filter((eachData) => {
        let returnedValue = true;
        for (const eachKeName of checkArrayOfObjectKeyNames) {
          if (
            (Object.prototype.toString.call(eachData?.[eachKeName]) === "[object Object]" &&
              !eachData?.[eachKeName]?.id) ||
            !eachData?.[eachKeName]
          ) {
            returnedValue = false;
            break;
          }
        }
        return returnedValue;
      });
      if (filteredArrayOfItems.length > 0) {
        returnedValidityObject = { isValid: true, msg: "" };
      } else {
        returnedValidityObject = {
          isValid: false,
          msg: ["پر کردن حداقل یک آیتم به درستی اجباری می‌باشد"],
        };
      }
    } else {
      returnedValidityObject = { isValid: false, msg: ["پر کردن حداقل یک آیتم اجباری می‌باشد"] };
    }
  } else if (type === "sheba") {
    let isValid = validateIBAN(properData);
    returnedValidityObject = isValid
      ? { isValid: true, msg: "" }
      : { isValid: false, msg: ["شماره شبا معتبر نمی باشد"] };
  }

  return returnedValidityObject;
};

export default validate;
